import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import * as moment from 'moment';

@Component({
  selector: 'app-datepicker',
  templateUrl: './app-datepicker.component.html',
  styleUrls: ['./app-datepicker.component.scss']
})
export class AppDatepickerComponent implements OnInit, OnChanges {

  @Input() current: Date;
  @Input() disabled: boolean;
  @Output() notify: EventEmitter<any> = new EventEmitter<any>();
  constructor() {}

  ngOnInit() {
    if (!this.current) {
      this.current = new Date();
    }
  }

  increment(type, interval) {
    if (!this.disabled) {
      if (type === 'd') {
        this.current = moment(this.current).add(interval, 'day').toDate();
      }
      if (type === 'm') {
        this.current = moment(this.current).add(interval, 'month').toDate();
      }
      if (type === 'year') {
        this.current = moment(this.current).add(interval, 'year').toDate();
      }
      this.changed(this.current);
    }
  }

  formatMonth() {
    return moment(this.current).format('MMM');
  }

  changed(current) {
    this.current = current;
    this.notify.emit(current.toISOString());
  }

  ngOnChanges(changes: SimpleChanges) {
    if (!this.current) { this.current = moment().toDate(); }
    this.current = new Date(this.current);
  }

}
